import { Helmet } from "react-helmet-async";

/**
 * Default site-wide meta. Pages can override with <Seo />.
 */
export default function SeoDefault() {
  return (
    <Helmet>
      <html lang="en" />
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#E63946" />
      <meta name="author" content="Gens Realty, LLC" />
      <meta
        name="keywords"
        content="Houston real estate, Houston homes for sale, Houston realtor, River Oaks homes, The Heights homes, Memorial homes, Montrose homes, Midtown condos, Houston MLS, Gens Realty"
      />
    </Helmet>
  );
}
